// prettier-ignore
const PT_BR = {
  title: "Franquias",
  items: [
    {
      city: "Mossoró / RN",
      image: "mossoro.png",
      link: "https://mossoro.roboeduc.com.br"
    },
    {
      city: "Maceió / AL",
      image: "maceio.png",
      link: "https://maceio.roboeduc.com.br"
    },
    {
      city: "Porto Alegre / RS",
      image: "poa.png",
      link: "https://poa.roboeduc.com.br"
    },
  ]
}

export const franchise = {
  PT_BR: PT_BR,
  PT_PT: PT_BR
}
